import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { HttpResponsesHandlersFactory, IHttpResponseHandlerSettings } from "@bbwt/modules/data-service";
import { IPagedData, PagedCrudService } from "@features/grid";
import { IGoverningBody } from "./governingbody";
import { IQueryCommand } from "@features/filter";
import { IRole } from "@main/roles";
import { SetLocalTimeZone } from "@bbwt/utils";
import { BroadcastService } from "@bbwt/modules/broadcasting";

@Injectable({
    providedIn: "root"
})
export class GoverningBodyService extends PagedCrudService<IGoverningBody> {
    readonly url = "api/governing-body";
    entityTitle = "Governing Body";
    static readonly GovBodyChangedEventName = "GovBodyChanged";
    static readonly functionalGutGovBodyName = "Functional Gut"; 
    

    constructor(http: HttpClient, handlersFactory: HttpResponsesHandlersFactory, private broadcastService: BroadcastService) {
        super(http, handlersFactory);
    }

    getAllGovBody(): Promise<IGoverningBody[]> {
        return this.handleRequest<IGoverningBody[]>(
            this.http.get<IGoverningBody[]>(`${this.url}/all-govBody`),
            this.handlersFactory.getForReadAll()
        );
    }

    getRolesPage(
        governingBodyId: string,
        queryCommand: IQueryCommand,
        responseHandlerSettings?: IHttpResponseHandlerSettings
    ): Promise<IPagedData<IRole>> {
        if (this.extendQueryCommand) {
            this.extendQueryCommand(queryCommand);
        }

        return this.handleRequest<IPagedData<IRole>>(
            this.http.get<IPagedData<IRole>>(`${this.url}/${governingBodyId}/roles-page`, {
                params: this.constructHttpParams(queryCommand)
            }),
            this.handlersFactory.getForReadByFilter(responseHandlerSettings)
        ).then(result => {
            result.items.forEach(item => this.modelUtcDateFields.forEach(utcField => (item[utcField] = SetLocalTimeZone(item[utcField]))));
            return result;
        });
    }

    getRoles(governingBodyId: string): Promise<IRole[]> {
        return this.handleRequest<IRole[]>(
            this.http.get<IRole[]>(`${this.url}/${governingBodyId}/roles`),
            this.handlersFactory.getForReadAll()
        );
    }

    getPlayerRole(governingBodyId: string): Promise<IRole> {
        return this.handleRequest<IRole>(
            this.http.get<IRole>(`${this.url}/${governingBodyId}/player-role`),
            this.handlersFactory.getForReadAll()
        );
    }

    getRole(governingBodyId: string, roleName: string ): Promise<IRole> {
        return this.handleRequest<IRole>(
            this.http.get<IRole>(`${this.url}/${governingBodyId}/role/${roleName}`),
            this.handlersFactory.getForReadAll()
        );
    }


    update(id: string, item: IGoverningBody, responseHandlerSettings?: IHttpResponseHandlerSettings): Promise<IGoverningBody> {
        return super.update(id, item).then(result => {
            this.broadcastService.broadcast(GoverningBodyService.GovBodyChangedEventName, result);
            return result;
        });
    }

    createRole(governingBodyId: string, data: IRole, responseHandlerSettings?: IHttpResponseHandlerSettings): Promise<IRole> {
        return this.handleRequest<IRole>(
            this.http.post<IRole>(`${this.url}/${governingBodyId}/roles`, data),
            this.handlersFactory.getForCreate("Role", responseHandlerSettings)
        );
    }

    getEnableSelfDirectedGymRecovery(): Promise<boolean> {
        return this.handleRequest<boolean>(
            this.http.get<boolean>(`${this.url}/enableSelfDirectedGymRecovery`),
            this.handlersFactory.getDefault()
        );
    }
}
